export const deleteFalsyKeys = <T extends {}>(baseObject: T) =>
    Object.keys(baseObject).reduce(
        (acc, key) => ({
            ...acc,
            ...(!!baseObject[key as keyof T] ? {[key]: baseObject[key as keyof T]} : {})
        }),
        {}
    );
export const deleteFalsyKeys = <T extends {}>(baseObject: T) =>
    Object.keys(baseObject).reduce(
        (acc, key) => ({
            ...acc,
            ...(!!baseObject[key as keyof T] ? {[key]: baseObject[key as keyof T]} : {})
        }),
        {}
    );
